import React, { VFC } from "react";
import styled from "styled-components";
import { AboutInfo } from "~/models/aboutInfo";
import { Project } from "~/models/project";
import {
  calculateHelpfulAndUserReactionCount,
  QuestionAnswer,
} from "~/models/questionAnswer";
import { Topic } from "~/models/topic";
import PreviewShareAction from "./PreviewShareAction";
import ShareAction from "./ShareAction";

interface Props {
  aboutInfo?: AboutInfo;
  increaseFeedbackHelpfulCallback?: () => void;
  increaseFeedbackHelpfulUrl?: string;
  isAmp?: boolean;
  isPreview?: boolean;
  project: Project;
  questionAnswer: QuestionAnswer;
  topic: Topic;
}

const FooterShareActions: VFC<Props> = ({
  aboutInfo,
  increaseFeedbackHelpfulCallback,
  increaseFeedbackHelpfulUrl,
  isAmp,
  isPreview,
  project,
  questionAnswer,
  topic,
}) => {
  return (
    <>
      <ShareDescription>
        この記事が気に入ったら応援お願いします🙏
      </ShareDescription>
      <Actions>
        {isPreview ? (
          <PreviewShareAction
            helpfulCount={calculateHelpfulAndUserReactionCount(questionAnswer)}
          />
        ) : (
          <ShareAction
            increaseFeedbackHelpfulCallback={increaseFeedbackHelpfulCallback}
            increaseFeedbackHelpfulUrl={increaseFeedbackHelpfulUrl}
            aboutInfo={aboutInfo}
            isAmp={isAmp}
            project={project}
            questionAnswer={questionAnswer}
            topic={topic}
          />
        )}
      </Actions>
    </>
  );
};

const Actions = styled.div`
  align-items: center;
  display: grid;
  gap: 40px;
  grid-auto-flow: column;
  justify-content: center;
  margin-top: 12px;
  padding: 12px 0;
`;

const ShareDescription = styled.div`
  color: var(--cap-clr);
  font-weight: 700;
  font-size: 18px;
  line-height: 32px;
  margin-top: 24px;
  text-align: center;
`;

export default FooterShareActions;
